// extracted by mini-css-extract-plugin
export default {"privacyIndicator":"PrivacyIndicator_privacyIndicator__0rXn8"};